var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0125 7.99377V55.8688H12.0437V7.99377H52.0125ZM52.0125 3.99377H12.0437C9.83745 3.99377 8.0437 5.78752 8.0437 7.99377V55.8688C8.0437 58.075 9.83745 59.8688 12.0437 59.8688H52.0125C54.2187 59.8688 56.0125 58.075 56.0125 55.8688V7.99377C56.0125 5.78127 54.2187 3.99377 52.0125 3.99377Z",
    fill: "#A3BDD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859 9.97595V7.97595H32.0297V9.97595H26.5859ZM26.5859 13.976V11.976H32.0297V13.976H26.5859ZM26.586 17.976V15.976H32.0298V17.976H26.586ZM26.586 21.976V19.976H32.0298V21.976H26.586ZM26.5857 25.995V23.995H32.0294V25.995H26.5857ZM32.0594 11.9889V9.98889H37.5032V11.9889H32.0594ZM32.0595 15.9889V13.9889H37.5033V15.9889H32.0595ZM32.0595 19.9889V17.9889H37.5033V19.9889H32.0595ZM32.0595 23.9889V21.9889H37.5033V23.9889H32.0595ZM32.0655 28.0079V26.0079H37.5093V28.0079H32.0655Z",
    fill: "#A3BDD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19409 29.9971V27.9971H53.0441V29.9971H9.19409Z",
    fill: "#A3BDD3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0124 59.8938H33.1375V48.8938C33.1375 46.6875 34.9312 44.8938 37.1375 44.8938H56.0062C58.2124 44.8938 60.0062 46.6875 60.0062 48.8938V55.8938C60.0124 58.1063 58.2187 59.8938 56.0124 59.8938Z",
    fill: "#85A6BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6313 48.1875V49.35L39.4813 55.8625H44.9313V57.1125H37.5688V55.9625L42.7313 49.4375H37.9438V48.1875H44.6313ZM47.5813 48.1875V57.1125H46.1188V48.1875H47.5813ZM53.0313 48.1875C55.1813 48.1875 56.2688 49.1 56.2688 50.925C56.2688 52.7625 55.1813 53.6875 53.0063 53.6875H50.7938V57.1125H49.3313V48.1875H53.0313ZM50.7938 52.4375H52.9188C53.5688 52.4375 54.0438 52.3125 54.3438 52.0875C54.6438 51.85 54.7938 51.4625 54.7938 50.925C54.7938 50.3875 54.6313 50.0125 54.3313 49.7875C54.0313 49.55 53.5563 49.4375 52.9188 49.4375H50.7938V52.4375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipIcon);
export default __webpack_public_path__ + "static/media/zip-icon.c283e1042e037431ea387cfd49564488.svg";
export { ForwardRef as ReactComponent };